<script>
import * as XLSX from 'xlsx'

export default {
  name: 'BalanceIssueManualForm',
  data() {
    return {
      balanceIssueRequestToUpload: [],
      uploadFileName: 'Выберите файл',
      uploadError: '',
      createError: '',
      topt: '',
    }
  },
  computed: {
    uploadStats () {
      const users = {}
      const amounts = {
        rub: 0,
        usd: 0,
        eur: 0
      }

      this.balanceIssueRequestToUpload.forEach((item) => {
        users[item.user_id] = true
        amounts[item.currency] += item.sum
      })

      return `Вы хотите выдать баланс ${Object.keys(users).length} пользователям на сумму: ${amounts.rub}₽ | ${amounts.usd}$ | ${amounts.eur}€`
    }
  },
  methods: {
    createBalanceIssueRequest() {
      const body = {
        "code": this.topt,
        "issues_requests": this.balanceIssueRequestToUpload,
        "issue_type": "full_manual"
      }

      fetch(
        `https://auth.apineural.com/api/user/admin/balance/issues`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.$store.state.tokens.access}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (!data.status) {
            const errorCodeToText = {
              'invalid_topt': 'Неверный код 2фа',
              'admin_balances_limits_exceeded': 'Вы превысили свои лимиты по выдаче баланса'
            }

            this.createError = errorCodeToText[data.error_code] || data.error_code
            return
          }

          this.resetAllFields()
        })
        .catch((err) => {
          console.log('error', err)
        })
    },
    onFileInput(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.uploadFileName = file.name;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        this.balanceIssueRequestToUpload = XLSX.utils.sheet_to_json(worksheet).map((item) => {
          return {
            "user_id": item.user_id,
            "sum": item.sum,
            "currency": item.currency,
            "comment": item.comment || ''
          }
        })
      };
      reader.readAsArrayBuffer(file);
    },
    resetAllFields () {
      this.createError = ''
      this.uploadError = ''
      this.uploadFileName = 'Выберите файл'
      this.balanceIssueRequestToUpload = []
      this.topt = ''

      this.$refs.excelFile.value = '';
    }
  }
}
</script>

<template>
  <div class="balances__multi__form">
    <div class="title-block">
      <p>Загрузите Excel файл</p>
      <p>Формат: user_id | sum | currency | comment</p>
    </div>

    <div class="separator"></div>

    <div class="file-block">
      <p v-if="balanceIssueRequestToUpload.length > 0">{{uploadStats}}</p>
      <p class="error" v-if="uploadError.length > 0">{{uploadError}}"></p>
      <input ref="excelFileManual" type="file" id="excelFileManual" name="excelFileManual" @input="onFileInput">
      <div class="file-block__flex">
        <label for="excelFileManual">
          Загрузить
        </label>
        <p>{{ uploadFileName }}</p>
      </div>
    </div>

    <div class="separator"></div>
    <div class="submit-block">
      <div class="inputWrapper">
        <span>2FA:</span>
        <input type="text" placeholder="2FA" class="userId" v-model="topt" />
      </div>
      <button @click="createBalanceIssueRequest">Отправить</button>
      <p v-if="createError.length > 0" class="error">{{ createError }}</p>
    </div>
  </div>
</template>

<style scoped>

</style>
